var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _rect3, _path9, _path10, _path11, _path12, _path13, _rect4, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.3984,
    y: 0.621094,
    width: 13.4727,
    height: 15.6357,
    rx: 2,
    transform: "rotate(90 31.3984 0.621094)",
    fill: "#252b41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3389 4.79492H26.823",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3389 8.36816H26.823",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3389 10.3496H26.823",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5801 15.7822L22.5288 13.9614L24.6313 13.9614L23.5801 15.7822Z",
    fill: "#252b41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1562,
    y: 17.7314,
    width: 13.4727,
    height: 15.6357,
    rx: 2,
    transform: "rotate(90 16.1562 17.7314)",
    fill: "#252b41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66895 22.1719H12.0078",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66895 25.7451H12.0078",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66895 27.7266H12.0078",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33887 15.9668L9.39011 17.7876H7.28763L8.33887 15.9668Z",
    fill: "#252b41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.520508,
    y: 0.621094,
    width: 13.4727,
    height: 15.6357,
    rx: 2,
    fill: "#252b41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58789 4.79492H10.9268",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58789 8.36816H10.9268",
    stroke: "white",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58789 10.3496H10.9268",
    stroke: "white",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58789 12.21H10.9268",
    stroke: "white",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7627 8.43848L13.9419 9.48972L13.9419 7.38724L15.7627 8.43848Z",
    fill: "#252b41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9248,
    y: 15.5684,
    width: 13.4727,
    height: 15.6357,
    rx: 2,
    fill: "#ccb46f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4189 20.0098H27.9031",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4189 23.584H27.9031",
    stroke: "white",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4189 25.5645H27.9031",
    stroke: "white",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4189 27.4258H27.9031",
    stroke: "white",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0279 24.437L16.2071 23.3858L18.0279 22.3345L18.0279 24.437Z",
    fill: "#ccb46f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f58ff7448dfed57378c011fb13d553b3.svg";
export { ForwardRef as ReactComponent };